import React from "react";

const CondoAdminAirdrop = () => {
  return (
    <div className="condo-admin-dashboard-pg">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div
              style={{
                display: "flex",
                height: "90vh",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <h3> Coming soon</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CondoAdminAirdrop;
